const setTitle = (newTitle) => {
  const titleElement = document.querySelector('title[data-title="default"]');
  if (titleElement) {
    titleElement.textContent = newTitle;
  }
};

export const usePageMeta = (defaultTitle) => {
  const updateTitle = (newTitle = defaultTitle) => {
    if (newTitle) setTitle(newTitle);
  };

  return updateTitle;
}; 